function c(n, e) {
  const o = {};
  for (let t = 0; t < n.length; t++) {
    const s = e(n[t], t, n), p = o[s] || [];
    p.push(n[t]), o[s] = p;
  }
  return o;
}
function u(n, e) {
  const o = new Array(n.length);
  for (let t = 0; t < n.length; t++)
    o[t] = e(n[t], t);
  return o;
}
function l(n, e) {
  return [n.slice(0, e), n.slice(e)];
}
export {
  c as g,
  u as m,
  l as s
};
//# sourceMappingURL=arrays-fVhvTJ84.js.map
